import React, { Component, Fragment } from 'react';
import UpdatePassword from './UpdatePassword';
import './index.css';

class Password extends Component {
  render() {
    return (
      <Fragment>
        <UpdatePassword {...this.props} />
      </Fragment>
    );
  }
}

export default Password;



// WEBPACK FOOTER //
// ./src/components/UpdatePassword/index.js